/** All Spending copy. brand.md: calm, plain, number first, never shaming, no emoji. */
export const copy = {
  pages: 'Spending pages',
  entryCount: (n: number) => (n === 1 ? '1 entry' : `${n.toLocaleString('en-US')} entries`),
  toSort: (n: number) => `${n} to sort`,
  moduleName: 'Spending',
  empty: 'No spending yet. Add one when you buy something; only the amount is needed.',
  loading: 'Loading…',
  add: 'Add',
  addSpending: 'Add spending',
  log: 'Log',
  save: 'Save',
  undo: 'Undo',
  edit: 'Edit',
  delete: 'Delete',
  restore: 'Restore',
  cancel: 'Cancel',
  added: (amount: string) => `Added ${amount}.`,
  deleted: (amount: string) => `Deleted ${amount}.`,
  restored: (amount: string) => `Restored ${amount}.`,
  saved: 'Saved.',
  categorized: (n: number) => `Set the category for ${n === 1 ? '1 entry' : `${n} entries`}.`,
  quickAddTitle: 'Add spending',
  editTitle: 'Edit spending',
  notePlaceholder: 'Note (optional)',
  amountLabel: 'Amount',
  amountAria: 'Amount in pesos',
  categoryLabel: 'Category',
  suggestedTag: 'suggested',
  suggested: (name: string) => `${name}?`,
  suggestedLabel: (name: string) => `Suggested category: ${name}. Tap to use it.`,
  useSuggestionFor: (name: string, what: string) => `Use ${name} for ${what}`,
  details: 'Details',
  hideDetails: 'Hide details',
  dateLabel: 'Date',
  methodLabel: 'Paid with',
  entriesTitle: 'Entries',
  entriesCount: (n: number) => (n === 1 ? '1 entry' : `${n} entries`),
  showOlder: 'Show older',
  drillEmpty: 'No entries here.',
  tidyLink: (n: number) => `${n} without a category · Tidy up`,
  tidyTitle: 'Tidy up',
  tidyIntro:
    'These have no category. Sort any of them if you like; leaving them as they are is fine.',
  tidyEmpty: 'Nothing to tidy up.',
  tidyListLabel: 'Entries without a category',
  selectAll: 'Select all',
  selectNone: 'Clear selection',
  moveTo: (n: number) => `Set category for ${n}`,
  categoriesTitle: 'Categories',
  categoriesIntro: 'Optional on every entry. Tap one to rename, hide or delete it.',
  noCategories: 'No categories. Add one below if you want them.',
  hiddenTitle: 'Hidden',
  unhide: 'Show',
  newCategory: 'New category',
  editCategoryTitle: 'Edit category',
  editCategoryLabel: (name: string) => `Edit ${name}`,
  categoryName: 'Name',
  hideFromQuickAdd: 'Hide from quick add',
  showInQuickAdd: 'Show in quick add',
  hideHint: 'Hidden categories keep their entries. You can show them again any time.',
  deleteCategory: 'Delete category',
  deleteHint: 'Its entries stay and show No category. You can undo right after.',
  categoryDeleted: (name: string) => `Deleted ${name}. Its entries now show No category.`,
  moveUp: (name: string) => `Move ${name} up`,
  moveDown: (name: string) => `Move ${name} down`,
  breakdownTitle: 'Breakdown',
  totalLabel: 'Total spent',
  byCategory: 'By category',
  overTime: 'Over time',
  dayOfWeek: 'Day of the week',
  bySource: 'Where it came from',
  byMethod: 'How you paid',
  topNotes: 'Top notes',
  repeats: 'Repeats',
  lastSixMonths: 'Last 6 months',
  noSpendingInRange: 'No spending in this period.',
  seeEntries: 'See entries',
  previousColumn: 'Previous',
  nextColumn: 'Next',
  previousPeriod: 'Previous period',
  nextPeriod: 'Next period',
  rangeLabel: 'Period',
  from: 'From',
  to: 'To',
  cadence: { weekly: 'Weekly', biweekly: 'Every two weeks', monthly: 'Monthly' },
  nextAround: (day: string) => `next around ${day}`,
  today: 'Today',
  spentToday: 'Spent today',
  nothingYetToday: 'Nothing yet today',
  thisWeek: 'This week',
  spentThisWeek: 'Spent this week',
  topCategories: 'Top categories',
  thisMonth: 'This month',
  nothingYet: 'Nothing yet',
  noCategory: 'No category',
  detail: {
    title: 'Spending',
    date: 'Date',
    category: 'Category',
    note: 'Note',
    method: 'Paid with',
    source: 'Added from',
    fund: 'Limit',
    account: 'From',
    removedFund: 'Removed limit',
    removedAccount: 'Removed account',
    removedCard: 'Removed card',
    fromCard: (card: string) => `${card} (credit card)`,
    none: 'None',
    history: 'History',
    deletedBanner: "This entry is deleted. It doesn't count anywhere until you restore it.",
    fromOtherModule: (moduleName: string) =>
      `Added by ${moduleName}. Change the amount or remove it there.`,
    notFound: "This entry doesn't exist.",
  },
  errors: {
    amount_required: 'Enter an amount.',
    amount_too_large: 'That amount is too large.',
    note_too_long: 'Keep the note under 200 characters.',
    bad_date: 'Pick a valid date.',
    bad_method: 'Pick a payment method.',
    name_required: 'Give the category a name.',
    name_too_long: 'Keep the name under 40 characters.',
    name_taken: 'You already have a category with that name.',
    not_found: "This entry doesn't exist.",
    not_deletable: 'This came from another module. Remove it there.',
    generic: "That didn't save. Try again.",
  },
} as const;

/** v0.7.5 back targets for the sub-screens' ‹ (the logical parent). */
export const SPENDING_BACK = { to: '/m/spending', label: copy.moduleName };
export const BREAKDOWN_BACK = { to: '/m/spending/breakdown', label: copy.breakdownTitle };
export const ENTRIES_BACK = { to: '/m/spending/entries', label: copy.entriesTitle };

export function errorText(code: string): string {
  return (copy.errors as Record<string, string>)[code] ?? copy.errors.generic;
}
